export default __webpack_public_path__ + "static/dochq-logo-rect-639fd602486c2f7be18ae23d5750e2ce.svg";